import endpoints from '../endpoints.ts';
import { fetch } from './helpers.ts';

const documentException = {
  create: {
    one: {
      status: async params => {
        const url = endpoints.documentException.create.one.status();
        return await fetch(url, 'POST', params);
      },
    },
  },
  read: {
    count: async () => {
      const url = endpoints.documentException.read.count();
      return await fetch<number | string>(url, 'GET');
    },
    one: {
      by: {
        id: async documentExceptionId => {
          const url = endpoints.documentException.read.one.by.id();
          return await fetch(url, 'GET', documentExceptionId);
        },
      },
    },
    many: {
      by: {
        filters: async params => {
          const url = endpoints.documentException.read.many.by.filters();
          return await fetch(url, 'GET', params);
        },
      },
    },
  },
};

export default documentException;
